import React from "react";
import { Redirect } from "react-router-dom";
import every from "lodash/every";
import includes from "lodash/includes";
import isArray from "lodash/isArray";
import isEqual from "lodash/isEqual";
import sortBy from "lodash/sortBy";
import PropTypes from "prop-types";

import { LimitationsContext } from "utils/Authenticated";

const Restricted = ({ children, redirect, requiredPermissions }) => (
  <LimitationsContext.Consumer>
    {(limitations) => {
      if (isEqual(sortBy(limitations), ["assets", "deals"])) return children;

      const hasPermission = (permission) => !includes(limitations, permission);
      const isAllowed = isArray(requiredPermissions)
        ? every(requiredPermissions, hasPermission)
        : hasPermission(requiredPermissions);

      if (isAllowed) return children;
      if (!isAllowed && !redirect) return null;

      return <Redirect to="/" />;
    }}
  </LimitationsContext.Consumer>
);

Restricted.propTypes = {
  children: PropTypes.node,
  requiredPermissions: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  redirect: PropTypes.bool,
};

export default Restricted;
